import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import "./PlanHomework.module.scss";

/**
 * Import components
 */
import DropDown from "components/UI/DropDown/DropDown";
import Tip from "components/UI/Tip/Tip";
import HomeworkBar from "components/UI/SubjectBar/SubjectBar";

/**
 * Import FontAwesome
 */
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import taskStore from "actions/task/store";
import {
    homeworkLoadExisting,
    homeworkUpdateDirectInput
} from "actions/new-homework";

import destroyHomework from "actions/homework/destroy";
import homeworkUpdate from "actions/homework/update";
const timeOptionArray = [
    5,
    10,
    15,
    20,
    25,
    30,
    40,
    50,
    60,
    75,
    90,
    120,
    150,
    180
];

const mapStateToProps = (state, props) => {
    return {
        subjects: state.user_subject.entities,
        colors: state.color.entities,
        user: state.authentication.user,
        tasks: state.task
    };
};

const mapDispatchToProps = {
    taskStore,
    homeworkLoadExisting,
    homeworkUpdateDirectInput,
    destroyHomework,
    homeworkUpdate
};

class PlanHomework extends Component {
    constructor() {
        super();

        this.state = {
            months: [
                "januari",
                "februari",
                "maart",
                "april",
                "mei",
                "juni",
                "juli",
                "augustus",
                "september",
                "oktober",
                "november",
                "december"
            ],
            steps: [
                {
                    name: "",
                    time: 10,
                    finished: false
                }
            ]
        };

        this.handleStepAmountChange = this.handleStepAmountChange.bind(this);
        this.handleStepNameChange = this.handleStepNameChange.bind(this);
        this.handleStepTimeChange = this.handleStepTimeChange.bind(this);
        this.storeTasks = this.storeTasks.bind(this);
        this.editHomework = this.editHomework.bind(this);
        this.deleteHomework = this.deleteHomework.bind(this);
        this.handleStepToggleFinished = this.handleStepToggleFinished.bind(
            this
        );
    }

    componentDidMount() {
        if (
            this.props.homework &&
            (this.props.homework.type == "learn" ||
                this.props.homework.type == "make_learn")
        ) {
            this.setState({
                steps: [
                    {
                        name: "",
                        time: 10,
                        finished: false
                    },
                    {
                        name: "HH",
                        time: 10,
                        finished: false
                    }
                ]
            });
        }
    }

    handleStepAmountChange(event) {
        let newCount = parseInt(event.target.value);
        let newSteps = this.state.steps;
        let difference = 0;

        if (newSteps[newSteps.length - 1].name == "HH") {
            newSteps[newSteps.length - 1].name = "";
        }

        if (newCount < this.state.steps.length) {
            if (!confirm("Let op, je huidige taken gaan verloren")) {
                return;
            }

            difference = this.state.steps.length - newCount;

            newSteps.splice(difference * -1, difference);
        } else {
            difference = newCount - this.state.steps.length;

            newSteps = this.state.steps;

            for (let index = 0; index < difference; index++) {
                newSteps.push({ name: "", time: 10 });
            }
        }

        if (
            this.props.homework &&
            (this.props.homework.type == "learn" ||
                this.props.homework.type == "make_learn")
        ) {
            newSteps[newSteps.length - 1].name = "HH";
        }

        this.setState({ steps: newSteps });
    }

    handleStepNameChange(value, index) {
        let newSteps = this.state.steps;
        let newStep = newSteps[index];
        newStep.name = value;

        newSteps[index] = newStep;

        this.setState({ steps: newSteps });
    }

    handleStepTimeChange(value, index) {
        let newSteps = this.state.steps;
        let newStep = newSteps[index];
        newStep.time = parseInt(value);

        newSteps[index] = newStep;

        this.setState({ steps: newSteps });
    }

    handleStepToggleFinished(index) {
        let newSteps = this.state.steps;
        let newStep = newSteps[index];
        newStep.finished = !newStep.finished;

        newSteps[index] = newStep;

        this.setState({ steps: newSteps });
    }

    editHomework() {
        this.props.handleHomeworkClick();
    }

    deleteHomework() {
        if (
            confirm(
                "Weet je zeker dat je het huiswerk en de bijbehorende taken wil verwijderen?"
            )
        ) {
            this.props
                .destroyHomework(this.props.homework.id)
                .then(result => {
                    this.props.handleClose();
                })
                .catch(error => {
                    console.error(error);
                    alert(
                        "Er ging iets mis met het verwijderen van het huiswerk"
                    );
                });
        }
    }

    storeTasks() {
        let responses = 0;
        let finishedSteps = 0;

        for (let index = 0; index < this.state.steps.length; index++) {
            let step = this.state.steps[index];
            if (step.finished) {
                finishedSteps++;
            }
            this.props
                .taskStore({
                    ...step,
                    order: index + 1,
                    homework_id: this.props.homework.id,
                    status: step.finished ? "finished" : "not_started"
                })
                .then(result => {
                    responses++;

                    //wait until all tasks have been stored in DB
                    if (responses == this.state.steps.length) {
                        if (finishedSteps == this.state.steps.length) {
                            //update homework to reflect planned state
                            this.props.homeworkUpdate({
                                ...this.props.homework,
                                note: this.props.homework.note
                                    ? this.props.homework.note
                                    : "",
                                hasBeenPlanned: true
                            });
                        }
                        this.props.handleClose();
                    }
                })
                .catch(error => {
                    alert(
                        "Er ging iets mis met het inplannen van het huiswerk."
                    );
                });
        }
    }

    render() {
        const { homework, user } = this.props;

        const { months } = this.state;

        let subject = this.props.subjects.byId[homework.user_subject_id];

        let stepCreators = [];

        for (let index = 0; index < this.state.steps.length; index++) {
            stepCreators.push(
                <StepCreator
                    index={index}
                    step={this.state.steps[index]}
                    handleTextChange={this.handleStepNameChange}
                    handleTimeChange={this.handleStepTimeChange}
                    toggleCheck={this.handleStepToggleFinished}
                    user={user}
                />
            );
        }

        let abbreviation = "";
        let color = null;
        if (subject.color_id) {
            color = this.props.colors.byId[subject.color_id];
            color = color && color.color;
        }
        if (subject.subject_abbreviation) {
            abbreviation = subject.subject_abbreviation;
        }

        return (
            <div styleName="input-content">
                <div styleName="card-content">
                    <h4 styleName="title">Huiswerk inplannen</h4>
                    <HomeworkBar
                        homework={this.props.homework}
                        disableContextMenu={true}
                        destroyItem={this.destroyItem}
                        isRecurring={
                            this.props.period && this.props.period.isRecurring
                        } //wordt alleen hier gebruikt? Straks checken. Dan gewoon event in props meegegven
                        color={color}
                        abbreviation={abbreviation}
                        date={homework.date}
                        note={homework.note}
                        image={homework.image}
                        style={{ margin: "0" }}
                    />
                    {!this.props.past && (
                        <Fragment>
                            <div styleName="homework-buttons">
                                <p
                                    onClick={this.editHomework}
                                    styleName="change "
                                >
                                    Huiswerk aanpassen
                                </p>
                                <p
                                    onClick={this.deleteHomework}
                                    styleName="delete "
                                >
                                    Huiswerk verwijderen
                                </p>
                            </div>
                        </Fragment>
                    )}

                    <div styleName="tip-wrapper">
                        <p>Opdelen in taken</p>
                        <Tip
                            tip="Om leerstof beter te onthouden, kun je beter vaak herhalen dan alles er in één keer in te stampen. Zorg er daarom voor dat je, bij het in stukken hakken van je huiswerk, het vorige herhaalt. Bewaar de laatste dag altijd om alles te herhalen."
                            image="/images/tips/5.png"
                            style={{ width: "243px", left: "3px" }}
                        />
                    </div>
                    <DropDown border>
                        <select
                            value={this.state.steps.length}
                            onChange={this.handleStepAmountChange}
                        >
                            <option value="1">1 taak</option>
                            <option value="2">2 taken</option>
                            <option value="3">3 taken</option>
                            <option value="4">4 taken</option>
                            <option value="5">5 taken</option>
                            <option value="6">6 taken</option>
                            <option value="7">7 taken</option>
                            <option value="8">8 taken</option>
                            <option value="9">9 taken</option>
                            <option value="10">10 taken</option>
                            <option value="11">11 taken</option>
                            <option value="12">12 taken</option>
                            <option value="13">13 taken</option>
                            <option value="14">14 taken</option>
                            <option value="15">15 taken</option>
                            <option value="16">16 taken</option>
                            <option value="17">17 taken</option>
                            <option value="18">18 taken</option>
                            <option value="19">19 taken</option>
                            <option value="20">20 taken</option>
                            <option value="21">21 taken</option>
                            <option value="22">22 taken</option>
                            <option value="23">23 taken</option>
                            <option value="24">24 taken</option>
                            <option value="25">25 taken</option>
                        </select>
                    </DropDown>

                    <div styleName="tip-wrapper">
                        <p>Taken beschrijven (max 30 tekens)</p>
                        <Tip
                            tip="Door met de tijdsindicatie te werken leer je van jezelf. Hoe lang heb jij nodig om te leren voor een toets?"
                            image="/images/tips/6.png"
                            style={{ width: "243px", left: "3px" }}
                        />
                    </div>

                    {stepCreators}

                    <div styleName="buttons">
                        <p onClick={this.props.handleClose}>Annuleer</p>
                        <p onClick={this.storeTasks} styleName="save">
                            Opslaan
                        </p>
                    </div>
                </div>
            </div>
        );
    }
}

class StepCreator extends Component {
    constructor() {
        super();

        this.handleTextChange = this.handleTextChange.bind(this);
        this.handleTimeChange = this.handleTimeChange.bind(this);
    }

    handleTextChange(event) {
        this.props.handleTextChange(event.target.value, this.props.index);
    }

    handleTimeChange(event) {
        this.props.handleTimeChange(event.target.value, this.props.index);
    }

    render() {
        let options = [];

        if (this.props.user && this.props.user.use_timer) {
            for (let index = 0; index < timeOptionArray.length; index++) {
                options.push(
                    <option key={index} value={timeOptionArray[index]}>
                        {timeOptionArray[index]} min
                    </option>
                );
            }
        } else {
            options.push(
                <option key={1} value={10}>
                    -
                </option>
            );
        }

        return (
            <div styleName="step-creator">
                <input
                    value={this.props.step.name}
                    onChange={this.handleTextChange}
                    styleName="input"
                    type="text"
                    placeholder="Bijv. par 1,2,3"
                    maxLength="30"
                />
                <DropDown border>
                    <select
                        value={this.props.step.time}
                        onChange={this.handleTimeChange}
                    >
                        {options}
                    </select>
                </DropDown>
                <div
                    onClick={() => this.props.toggleCheck(this.props.index)}
                    styleName={`checkbox ${
                        this.props.step.finished ? "checked" : ""
                    }`}
                >
                    <FontAwesomeIcon icon={["fa", "check"]} />
                </div>
            </div>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(PlanHomework);
